export default __webpack_public_path__ + "static/ec-logo-a2a6c353e449e31e9e8a2dafb5e7ebb6.jpg";